/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_ExportedInputs */

const cs_gdpr_exported = /** @type {(inputs: Gdpr_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export stažen a zapsán do auditu.`)
};

const en_gdpr_exported = /** @type {(inputs: Gdpr_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export downloaded and logged.`)
};

/**
* | output |
* | --- |
* | "Export downloaded and logged." |
*
* @param {Gdpr_ExportedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_exported = /** @type {((inputs?: Gdpr_ExportedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_ExportedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_exported(inputs)
	return cs_gdpr_exported(inputs)
});